import React from 'react';
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import { LatLng } from 'leaflet';
import '../css/mapSection.css';

function MapSection() {
  

  return (
    <section className="map-section" id="map">
      <h2>Location</h2>
      <iframe src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d13993.14982164577!2d24.7536111!3d-28.7408333!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x1e9b1a568b03f355%3A0xc570802add5e2cf4!2sMittah%20Seperepere%20Convention%20Centre!5e0!3m2!1sen!2sza!4v1732712088911!5m2!1sen!2sza" width="600" height="450" style={{border:'0'}} allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
    </section>
  );
}

export default MapSection;
